const actions = {
  SetLogin ({commit}, data) {
    return new Promise((resolve, reject) => {
      commit('LOGIN', data)
      resolve()
    })
  }
}
export default actions
